/* expel.gg E theme: shared bits. Page-specific scripts live at the end of each section. */
(function () {
  // YouTube thumbnails (snippets/e-yt-img.liquid): maxresdefault is missing for some videos, and YouTube then serves a
  // 120x90 grey stand-in (or a 404) instead of a real frame. Fall back to hqdefault, which every video has.
  //
  // Detection by aspect ratio: the stand-in is 120x90 (4:3), a real maxres frame is 1280x720 (16:9). The ratio survives srcset
  // density correction (naturalWidth does not: with srcset it is intrinsic / density, so "=== 120" misses it). That correction
  // rounds to whole pixels, which at 4-9x density moves 4:3 to e.g. 13/10, so the test is "closer to 4:3 than to 16:9"
  // (ratio < 1.55) rather than an exact 4:3 match. Only a maxresdefault URL is judged: mqdefault is 16:9, hqdefault and
  // sddefault are legitimately 4:3 (black bars, cropped by the card).
  var SPLIT = (4 / 3 + 16 / 9) / 2;  // 1.555...

  function isStandIn(i) {
    var src = i.currentSrc || i.src || '';
    if (src.indexOf('/maxresdefault') < 0) return false;
    if (!i.naturalWidth || !i.naturalHeight) return false;
    return i.naturalWidth / i.naturalHeight < SPLIT;
  }

  function swap(i) {
    i.dataset.ytFixed = '1';
    i.removeAttribute('srcset');
    i.src = 'https://i.ytimg.com/vi/' + i.dataset.yt + '/hqdefault.jpg';
  }

  // an <img data-yt> that has finished (loaded or failed): swap it when it is a stand-in or a failure
  function check(i) {
    if (!i || i.tagName !== 'IMG' || !i.dataset || !i.dataset.yt || i.dataset.ytFixed) return;
    if (!i.complete) return;
    if (i.naturalWidth === 0 || isStandIn(i)) swap(i);  // naturalWidth 0 on a finished image = it failed
  }

  function onEvent(e) {
    var i = e.target;
    if (!i || i.tagName !== 'IMG' || !i.dataset || !i.dataset.yt || i.dataset.ytFixed) return;
    if (e.type === 'error') swap(i);
    else if (isStandIn(i)) swap(i);
  }

  // load / error do not bubble, so listen in the capture phase on the document
  document.addEventListener('load', onEvent, true);
  document.addEventListener('error', onEvent, true);

  // this script is deferred: eager and cached images can already be finished, and their load event is gone
  function scan() {
    var imgs = document.querySelectorAll('img[data-yt]');
    for (var k = 0; k < imgs.length; k++) check(imgs[k]);
  }
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
})();
